import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {ContactDetailsComponent} from '../../components/ControlGroups/ContactDetails.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';
import { StatementDetailsComponent } from '../ControlGroups/StatementDetails.component';
import { AccountingDetailsComponent } from '../ControlGroups/AccountingDetails.component';
import { MICRDetailsComponent } from '../ControlGroups/MICRDetails.component';
import { PayerLinkageDetailsComponent } from '../ControlGroups/PayerLinkageDetails.component';
import BaseNewOutletRequestComponent from 'src/app/baseclasses/BaseNewOutletRequest.component';

@Component({
  selector: 'my-createpayer-request',
  templateUrl: './CreatePayerRequest.component.html'
})
export class CreatePayerRequestComponent extends BaseNewOutletRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(StatementDetailsComponent) statementDetailsComponent: StatementDetailsComponent;
    @ViewChild(AccountingDetailsComponent) accountingDetailsComponent: AccountingDetailsComponent;
    // @ViewChild(MICRDetailsComponent) micrDetailsComponent: MICRDetailsComponent;
    @ViewChild(PayerLinkageDetailsComponent) payerLinkageDetailsComponent: PayerLinkageDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor() 
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
    }

    ngAfterViewInit() {
        super.subscribeToOverallAccountCopyMethodsInContactDetailsSection();
        super.subscribeToOverallAccountCopyMethodsInBillingAddressSection();
        super.ngAfterViewInit();
        
    }

    getUpdateNeededValue(): number {
      return enums.UpdateNeededEnum.Update;
  }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.Payer,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            ContactInfos: this.contactDetailsComponent.contactGridComponent.records,
            StatementInfo: this.statementDetailsComponent.statementInfo,
            AccountingInfo: this.accountingDetailsComponent.accountingInfo,
            //MICRInfo: this.micrDetailsComponent.micrInfo,
            PayerLinkageInfo: this.payerLinkageDetailsComponent.payerLinkageInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        //this.requestToSave.PayerLinkageInfo.CustomerNumbers = this.payerLinkageDetailsComponent.getCustomerNumbers();
        this.requestToSave.PayerLinkageCustomers = this.payerLinkageDetailsComponent.getPayerLinkageCustomers();
        
        this.requestToSave.RequestPaymentOptions = util.RequestUtil.LoadRequestPaymentOptions(this.requestToSave, this.accountingDetailsComponent.paymentOptionMultiSelectComponent);
        
        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);

        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);
    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

}